import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { authAPI } from '@/api/new-api'
import { CREATE_BUILDING } from '@/reducers/buildingSelectorReducer'
import { Building } from '@/reducers/types'
import { composeFormData } from '@/utils'

export const createBuilding = async (data: Record<string, unknown>) => {
  const response = await authAPI.post<Building>('/building', composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useCreateBuilding = () => {
  const dispatch = useDispatch()

  return useMutation({
    mutationFn: createBuilding,
    onSuccess: (building) => {
      dispatch({ buildingData: building, type: CREATE_BUILDING })
    },
  })
}
